import { Navigate, Route } from 'react-router-dom'

import UserAccount from 'Components/Pages/UserAccount'
import OrderHistory, { OrderHistoryWrapperMobileLayout } from 'Components/Elements/OrderHistory/OrderHistoryWrapper'
import Subscriptions from 'Components/Elements/Subscriptions/SubscriptionsWrapper'
import PersonalDetailsWrapper from 'Components/Elements/Settings/Wrapper'
import Invite from 'Components/Elements/Invite/Invite'
import { InviteWrapperMobileLayout } from 'Components/Elements/Invite/InviteWrapper'
import CustomReferral from 'Components/Elements/Invite/ReferralLinks/CustomReferral/CustomReferral'
import SharingSocial from 'Components/Elements/Invite/ReferralLinks/SharingSocial/SharingSocial'
import ChangeMobilePhone from 'Components/Elements/Settings/ChangeMobile/ChangeMobilePhone'
import SuccessChangePhoneNumber from 'Components/Elements/Settings/ChangeMobile/SuccessChangePhoneNumber'
import SavedCreditCard from 'Components/SavedCreditCard/SavedCreditCard'
import SavedCreditCardMobileWrapper from 'Components/SavedCreditCard/Elements/SavedCreditCardMobileWrapper'

const UserRoutes = ({ isCompactLayout, userPath, withLoginWrapper }) => {
    const withUserAccountLayout = (children, props = {}) =>
        withLoginWrapper(<UserAccount {...props}>{children}</UserAccount>)

    const withOrderHistoryMobileLayout = children =>
        withLoginWrapper(
            <OrderHistoryWrapperMobileLayout>
                {children}
            </OrderHistoryWrapperMobileLayout>
        )

    return [
        <Route
            key="user-settings"
            path="/user/settings/*"
            element={withLoginWrapper(<PersonalDetailsWrapper />)}
        />,
        <Route
            key="user-settings-change-phone"
            path="/user/settings/change-phone-number"
            element={withLoginWrapper(<ChangeMobilePhone />)}
        />,
        <Route
            key="user-settings-change-mobile-success"
            path="/user/settings/change-mobile-number-success"
            element={withLoginWrapper(<SuccessChangePhoneNumber />)}
        />,
        <Route
            key="user-orderhistory"
            path="/user/orderhistory"
            element={
                isCompactLayout
                    ? withOrderHistoryMobileLayout(<OrderHistory />)
                    : withUserAccountLayout(<OrderHistory />)
            }
        />,
        <Route
            key="user-payment-methods"
            path="/user/payment-methods"
            element={
                isCompactLayout
                    ? withLoginWrapper(
                          <SavedCreditCardMobileWrapper>
                              <SavedCreditCard />
                          </SavedCreditCardMobileWrapper>
                      )
                    : withUserAccountLayout(<SavedCreditCard />)
            }
        />,
        <Route
            key="user-orderhistory-detail"
            path="/user/orderhistory/:order_id"
            element={
                isCompactLayout
                    ? withOrderHistoryMobileLayout(<OrderHistory />)
                    : withUserAccountLayout(<OrderHistory />)
            }
        />,
        <Route
            key="user-subscriptions"
            path="/user/subscriptions/*"
            element={
                isCompactLayout
                    ? withLoginWrapper(<Subscriptions />)
                    : withUserAccountLayout(<Subscriptions />)
            }
        />,
        <Route
            key="user-invite"
            path="/user/invite"
            element={
                isCompactLayout
                    ? withLoginWrapper(<InviteWrapperMobileLayout />)
                    : withUserAccountLayout(<Invite />, {
                          secondChildren: <CustomReferral />,
                          thirdChildren: <SharingSocial />
                      })
            }
        />,
        <Route
            key="user-root"
            path="/user"
            element={isCompactLayout ? withLoginWrapper(<UserAccount />) : <Navigate to={userPath} replace />}
        />
    ]
}

export default UserRoutes

